site.ieSupport = {
	init: function () {

		$('#ieSupport .btn-more').click(function(e) {
			$('#ieSupport .row.more').slideToggle("slow");
			$('#ieSupport').toggleClass('show');
		});

	}
}

site.inits.push('site.ieSupport.init()');